// extracted by mini-css-extract-plugin
export var isPrintedCell = "_z2-1";
export var printerIcon = "_z2-0";